import { QueryClient, QueryClientProvider } from "react-query"
import {
  RolesStore,
  configStore,
  AgmodalStore,
  loginStore,
  routerStore,
} from "../state/CommonState"
import { useSnapshot } from "valtio"
import React, { useState, useEffect, useReducer } from "react"
import { RolesColumn } from "../components/ag-table/columns"
import {
  reducer,
  PAGE_CHANGED,
  PAGE_FILTER_CHANGED,
  PAGE_SIZE_CHANGED,
  PAGE_SORT_CHANGED,
  PAYLOAD_CHANGED,
  TOTAL_COUNT_CHANGED,
} from "../components/ag-table/ag-reducer"
import { RoleType } from "../state/Types"
import ApiAgTable from "../components/ag-table/api_ag-table"
import { loader } from "../util/loader"
import { useTable, useSortBy, usePagination } from "react-table"
import RoleUtils from "../util/RoleUtils"
import { ReactComponent as Loader } from "../assets/loader.svg"
import ReactTablePagination from "../components/ag-table/ReactTablePagination"
import { Sorting } from "../components/ag-table/ag-sorting"
import RolesApi from "../state/RolesApi"

const queryClient = new QueryClient()

const initialState = {
  queryPageIndex: 0,
  queryPageSize: 20,
  totalCount: 0,
  queryPageFilter: "",
  queryPageSortBy: [],
  queryPayload: {},
}

const DataTable = () => {
  useSnapshot(RolesStore)
  useSnapshot(AgmodalStore)
  useSnapshot(configStore)

  const [deactivatePopup, setDeactivatePopup] = useState(false)
  const [deactivateRoleData, setDeactivateRoleData] = useState(null)
  const [loading, setLoading] = useState(false)
  const domain = loginStore.email.split("@")[1]
  const [selectedFilter, setSelectedFilter] = useState("all")
  const [data, setData] = useState({ results: [] })

  const columns = domain === process.env.REACT_APP_ENTERPRISE_DOMAIN? RolesColumn : {}

  const [
    { queryPageIndex, queryPageSize, totalCount, queryPageFilter, queryPageSortBy, queryPayload },
    dispatch,
  ] = useReducer(reducer, initialState)

  useEffect(() => {
    if (queryPayload.filter && AgmodalStore.apiCall) {
      loader.show()
      ApiAgTable.rolesList(
        queryPageIndex,
        queryPageSize,
        queryPageFilter,
        queryPageSortBy,
        queryPayload
      )
        .then((res) => res.clone().json())
        .then(
          (resData) => {
            if (
              JSON.stringify(data?.results) !==
              JSON.stringify(resData.results?.roles)
            ) {
              if (
                JSON.stringify(data) !== JSON.stringify(resData.results) &&
                resData.results?.roles &&
                resData.results?.roles.length > 0
              ) {
                setData(resData)
                RolesStore.list = resData.results.roles
              } else {
                RolesStore.list = []
                setData({ count: 0, results: [] })
              }
            }
            loader.hide()
          },
          (err) => {
            console.log(err)
            loader.hide()
          }
        )
    }
  }, [
    queryPayload,
    queryPageIndex,
    queryPageSize,
    queryPageFilter,
    queryPageSortBy,
    AgmodalStore.apiCall,
  ])

  const totalPageCount = Math.ceil(totalCount / queryPageSize)

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    page,
    pageCount,
    pageOptions,
    gotoPage,
    previousPage,
    canPreviousPage,
    nextPage,
    canNextPage,
    setPageSize,
    state: { pageIndex, pageSize, sortBy },
  } = useTable(
    {
      columns,
      data: data?.results?.roles || [],
      initialState: {
        pageIndex: queryPageIndex,
        pageSize: queryPageSize,
        sortBy: queryPageSortBy,
      },
      manualPagination: true,
      pageCount: data ? totalPageCount : null,
      autoResetSortBy: false,
      autoResetExpanded: false,
      autoResetPage: false,
    },
    useSortBy,
    usePagination
  )
  const manualPageSize = []
  // Keep track of table state changes
  useEffect(() => {
    dispatch({ type: PAGE_CHANGED, payload: pageIndex })
  }, [pageIndex])

  useEffect(() => {
    dispatch({ type: PAGE_SIZE_CHANGED, payload: pageSize })
    gotoPage(0)
  }, [pageSize, gotoPage])

  useEffect(() => {
    dispatch({ type: PAGE_SORT_CHANGED, payload: sortBy })
    gotoPage(0)
  }, [sortBy, gotoPage])

  useEffect(() => {
    dispatch({ type: PAYLOAD_CHANGED, payload: { filter: selectedFilter } })
    gotoPage(0)
  }, [selectedFilter])

  useEffect(() => {
    if (data?.count) {
      dispatch({
        type: TOTAL_COUNT_CHANGED,
        payload: data.count,
      })
    }
  }, [data?.count])

  const handleDeletePopup = (roleData) => {
    setDeactivateRoleData(roleData)
    setDeactivatePopup(true)
  }

  const closePopup = () => {
    setDeactivatePopup(false)
    setDeactivateRoleData(null)
  }

  // Example state for handling error messages
const [deleteError, setDeleteError] = useState("")

const confirmDelete = async () => {
  console.log("Deleting role:", deactivateRoleData);
  setLoading(true);
  const updatedRoles = data.results.roles.filter(
    (role) => role._id !== deactivateRoleData._id
  );

  const updatedCount = data.count - 1;

  if (updatedRoles.length === 0 && queryPageIndex > 0) {
    dispatch({ type: PAGE_CHANGED, payload: queryPageIndex - 1 });
    gotoPage(0)
  }
  await RolesApi.apiDeleteRoleByID(setLoading, deactivateRoleData, async () => {
    setLoading(false)
    RolesStore.list = RolesStore.list.filter(
      (role) => role._id !== deactivateRoleData._id
    )
    setData({
      count: updatedCount,
      results: {
        ...data.results,
        roles: updatedRoles,
      },
    });
    closePopup()
  })
}


  const renderHeaderGroups = () =>
    headerGroups.map((headerGroup, hgIndex) => {
      const { key: headerGroupKey, ...restHeaderGroupProps } =
        headerGroup.getHeaderGroupProps()
      return (
        <tr key={headerGroupKey || `header-group-${hgIndex}`} {...restHeaderGroupProps}>
          <th key="sno">S.No</th>
          {headerGroup.headers.map((column, colIndex) => {
            const headerProps = column.getHeaderProps(column.getSortByToggleProps())
            const { key: headerKey, ...restHeaderProps } = headerProps
            return (
              <th key={headerKey || `header-col-${colIndex}`} {...restHeaderProps}>
                {column.render("Header")}
                <Sorting column={column} />
              </th>
            )
          })}
        </tr>
      )
    })

  const renderCell = (cell, cellIndex) => {
    const rowData = cell.row.original
    const cellProps = cell.getCellProps()
    const { key: cellKey, ...restCellProps } = cellProps

    switch (cell.column.Header) {
      case "Role Name":
        return (
          <td key={cellKey || `role-name-${cellIndex}`} {...restCellProps}>
            {/* <a
              onClick={(event) => {
                AgmodalStore.pageVisible = true
                AgmodalStore.modalPage = "viewRoles"
                event.stopPropagation()
              }}
            > */} 
              {rowData.roleName}
            {/* </a> */}
          </td>
        )
        case "Permissions":
          return (
            <td key={cellKey || `role-name-${cellIndex}`} {...restCellProps}>
              {/* <a
                onClick={(event) => {
                  AgmodalStore.pageVisible = true
                  AgmodalStore.modalPage = "viewRoles"
                  event.stopPropagation()
                }}
              > */} 
                {rowData.permissionsCount} Permissions
              {/* </a> */}
            </td>
          )
          case "Users":
        return (
          <td key={cellKey || `role-name-${cellIndex}`} {...restCellProps}>
            {/* <a
              onClick={(event) => {
                AgmodalStore.pageVisible = true
                AgmodalStore.modalPage = "viewRoles"
                event.stopPropagation()
              }}
            > */} 
              {rowData.usersCount} Users
            {/* </a> */}
          </td>
        )
      case "Actions":
        return (
          <td key={cellKey || `actions-${cellIndex}`} {...restCellProps}>
            <div className="dropdown post-options is-right is-hoverable" onClick={null}>
              <div className="dropdown-trigger">
                <button
                  className="button"
                  aria-haspopup="true"
                  aria-controls="dropdown-menu-post"
                >
                  <span className="icon is-small">
                    <i className="fas fa-ellipsis-h" aria-hidden="true"></i>
                  </span>
                </button>
              </div>
                {rowData.Status !== "Pending" && (
                  <div className="dropdown-menu" id="dropdown-menu-post" role="menu">
                    <div className="dropdown-content">
                      <a
                        href="/#"
                        className="dropdown-item"
                        onClick={(event) => {
                          RolesStore.RolesRec.set(rowData)
                          AgmodalStore.modalPage = "editRoles"
                          AgmodalStore.apiCall = false
                          AgmodalStore.pageVisible = true
                          event.stopPropagation()
                        }}
                      >
                        Modify
                      </a>
                      {rowData.usersCount === 0 && (
                      <a
                        href="/#"
                        className="dropdown-item"
                        onClick={(event) => {
                          event.preventDefault()
                          event.stopPropagation()
                          handleDeletePopup(rowData)
                        }}
                      >
                        Delete
                      </a>
                      )}
                    </div>
                  </div>
                )}
            </div>
          </td>
        )
      default:
        return (
          <td key={cellKey || `default-${cellIndex}`} {...restCellProps}>
            <span>{cell.render("Cell")}</span>
          </td>
        )
    }
  }

  const renderTableRows = () =>
    page.map((row, rowIndex) => {
      prepareRow(row)
      const rowProps = row.getRowProps()
      const { key: rowKey, ...restRowProps } = rowProps
      return (
        <tr key={row.id || rowKey || `row-${rowIndex}`} {...restRowProps}>
          <td key={`sno-${row.id || rowIndex}`}>
            {pageIndex * pageSize + rowIndex + 1}
          </td>
          {row.cells.map((cell, cellIndex) => renderCell(cell, cellIndex))}
        </tr>
      )
    })

  return (
    <>
      <div className="" id="listRoles">
        <h1 className="title">Roles</h1>
        <nav className="level">
          <div className="level-left">
            <div className="level-item">
              <p className="subtitle is-5">{data?.count} Roles</p>
            </div>
              <p className="level-item">
                <a
                  className="button"
                   style={{backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON, color: "#fff"}}
                  onClick={() => {
                    RolesStore.RolesRec.set(new RoleType())
                    AgmodalStore.modalPage = "newRoles"
                    AgmodalStore.apiCall = false
                    AgmodalStore.pageVisible = true
                  }}
                >
                  Add New Role
                </a>
              </p>
          </div>
        </nav>
        <div className="box">
          <div className="table-container" style={{ overflow: "initial" }}>
            <table className="table is-fullwidth is-small" {...getTableProps()}>
              <thead className="is-scrollable-header has-background-white-ter is-unselectable">
                {renderHeaderGroups()}
              </thead>
              <tbody
                className="contractlist"
                style={{ fontSize: "0.9rem" }}
                {...getTableBodyProps()}
              >
                {renderTableRows()}
              </tbody>
            </table>
            <ReactTablePagination
              page={page}
              gotoPage={gotoPage}
              previousPage={previousPage}
              nextPage={nextPage}
              canPreviousPage={canPreviousPage}
              canNextPage={canNextPage}
              pageOptions={pageOptions}
              pageSize={pageSize}
              pageIndex={pageIndex}
              pageCount={pageCount}
              setPageSize={setPageSize}
              manualPageSize={manualPageSize}
              dataLength={totalCount}
              rows={rows}
            />
          </div>
        </div>
      </div>

      {/* Delete Popup (Bulma Modal) */}
      {deactivatePopup && (
        <div className="modal is-active">
          <div className="modal-background" onClick={closePopup}></div>
          <div className="modal-card">
            <header className="modal-card-head">
              <p className="modal-card-title">Delete Role</p>
              <button className="delete" aria-label="close" onClick={closePopup}></button>
            </header>
            <section className="modal-card-body">
              <p>Are you sure you want to delete this role?</p>
              {deleteError && (
                <div className="notification is-danger" style={{ marginTop: "1rem" }}>
                  {deleteError}
                </div>
              )}
            </section>
            <footer className="modal-card-foot">
              <button className="button is-danger" onClick={confirmDelete}>
                {!loading ? "Delete" : <Loader className="spinner" />}
              </button>
              <button className="button" onClick={closePopup}>
                Cancel
              </button>
            </footer>
          </div>
        </div>
      )}
    </>
  )
}

const ListRoles = () => (
  <QueryClientProvider client={queryClient}>
    <DataTable />
  </QueryClientProvider>
)

export default ListRoles
